export const DEFAULT_SESSION_DURATION_MINUTES = 86_400;
export const STYTCH_MAX_SESSION_DURATION_MINUTES = 89_280;

const SESSION_DURATION_METADATA_KEY = 'mento_session_duration_minutes';

type OrganizationSessionPolicy = {
  trusted_metadata?: Record<string, unknown> | null;
};

export class SessionPolicyError extends Error {
  constructor(message = 'Invalid organization session policy') {
    super(message);
    this.name = 'SessionPolicyError';
  }
}

export function resolveSessionDurationMinutes(organization: OrganizationSessionPolicy): number {
  const metadata = organization.trusted_metadata;
  if (!metadata || !Object.hasOwn(metadata, SESSION_DURATION_METADATA_KEY)) {
    return DEFAULT_SESSION_DURATION_MINUTES;
  }

  const duration = metadata[SESSION_DURATION_METADATA_KEY];
  if (
    typeof duration !== 'number' ||
    !Number.isInteger(duration) ||
    duration < 5 ||
    duration > STYTCH_MAX_SESSION_DURATION_MINUTES
  ) {
    throw new SessionPolicyError();
  }

  return duration;
}

export function assertSessionWithinPolicy(
  organization: OrganizationSessionPolicy,
  startedAt: string,
  now = new Date()
): void {
  const deadline = resolveSessionPolicyDeadline(organization, startedAt);
  if (now.getTime() >= deadline.getTime()) {
    throw new SessionPolicyError('Your session has expired. Please sign in again.');
  }
}

export function resolveSessionPolicyDeadline(
  organization: OrganizationSessionPolicy,
  startedAt: string
): Date {
  const startedAtMillis = Date.parse(startedAt);
  if (!Number.isFinite(startedAtMillis)) {
    throw new SessionPolicyError('Invalid session start time');
  }

  const deadlineMillis = startedAtMillis + resolveSessionDurationMinutes(organization) * 60 * 1000;
  return new Date(deadlineMillis);
}
